<template>
  <div class="popup-layout" @click.self="close">
    <button class="btn btn-default close-button" @click="close">Close</button>
    <div class="popup-content-container">
      <v-card :height="height">
        <v-card-text>
          <slot />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.popup-layout {
  .close-button {
    float: right;
    margin-bottom: 10px;
    font-size: 12px;
    padding: 5px 30px;
  }

  .popup-content-container {
    clear: both;
  }

  .v-card__subtitle,
  .v-card__text,
  .v-card__title {
    padding: 30px;
  }
}
</style>